module.exports = __webpack_public_path__ + "static/media/backgroundPromoCode.eb801a1c.png";